import React, { useEffect, useState } from 'react';
import DocViewerModal from './DocViewerModal';

// Aperçu intégré des PDF générés par Hello Georges (devis, contrats, factures,
// attestations…) : au lieu d'ouvrir un nouvel onglet, le PDF s'affiche dans la
// visionneuse par-dessus la page. Sur mobile, les navigateurs n'affichent pas
// bien un PDF dans une iframe → on garde l'ouverture dans un onglet.

// Libellé affiché dans la barre de la visionneuse, d'après l'URL.
const LIBELLES = [
  [/\/enfants\/\d+\/contrat\/pdf/, "Contrat d'accueil"],
  [/\/enfants\/\d+\/avenant\/pdf/, 'Avenant'],
  [/\/enfants\/\d+\/attestation\/pdf/, 'Attestation de présence'],
  [/\/enfants\/\d+\/fiche\/pdf/, 'Fiche de transmission'],
  [/\/enfants\/\d+\/dossier\/pdf/, 'Dossier enfant'],
  [/\/devis\//, 'Devis'],
  [/\/contrats\//, 'Contrat'],
  [/\/factures\//, 'Facture'],
  [/\/documents-modeles\//, 'Documents & autorisations'],
  [/\/courriers\//, 'Courrier'],
  [/\/protocoles\//, 'Protocole'],
  [/\/refacturations\//, 'Convention de refacturation'],
  [/\/signatures\//, 'Document signé'],
];

// URL d'un PDF servi par l'API ? (hors téléchargements forcés)
function estPdfApi(href) {
  let u;
  try { u = new URL(href, window.location.href); } catch { return false; }
  if (u.origin !== window.location.origin || !u.pathname.startsWith('/api/')) return false;
  if (u.searchParams.get('download') === '1') return false;
  return /\/pdf$/.test(u.pathname) || /\.pdf$/i.test(u.pathname) || /^\/api\/signatures\/\d+\/document$/.test(u.pathname);
}

function libelle(href) {
  const path = new URL(href, window.location.href).pathname;
  const hit = LIBELLES.find(([re]) => re.test(path));
  return hit ? hit[1] : 'Document';
}

export const apercuDisponible = () =>
  !(window.matchMedia && window.matchMedia('(max-width: 767px), (pointer: coarse)').matches);

let ouvrir = null;   // branché par <PdfPreviewHost />

/** Ouvre un PDF dans la visionneuse (ou dans un onglet sur mobile). */
export function openPdf(url, titre) {
  if (ouvrir && apercuDisponible()) ouvrir({ url, titre: titre || libelle(url) });
  else window.open(url, '_blank');
}

/** À monter une fois à la racine : intercepte les clics sur les liens PDF de l'appli. */
export default function PdfPreviewHost() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    ouvrir = setDoc;
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.hasAttribute('download') || a.dataset.noPreview !== undefined) return;
      if (!estPdfApi(a.href) || !apercuDisponible()) return;
      e.preventDefault();
      setDoc({ url: a.href, titre: libelle(a.href) });
    };
    document.addEventListener('click', onClick);
    return () => { document.removeEventListener('click', onClick); ouvrir = null; };
  }, []);

  if (!doc) return null;
  return (
    <DocViewerModal url={doc.url} filename={doc.titre} kind="pdf" onClose={() => setDoc(null)} />
  );
}
